import { useCallback } from "react";

import { useDispatch } from "react-redux";

import { closeDispatchingModal } from "actions";

import { closeAllHashModals, returnToLocation } from "lib/navigation";

export const useCloseDialog = returnTo => {
  return useCallback(() => {
    if (returnTo) {
      returnToLocation(returnTo);
    } else {
      closeAllHashModals();
    }
  }, [returnTo]);
};

// https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
const MouseBackButton = 3;

export const useCloseStateDialog = modalType => {
  const dispatch = useDispatch();
  return useCallback(
    (event, target) => {
      if (
        event && // event is only defined when triggered by the close from Mui Dialog
        event.type === "mouseup" &&
        target === "backdropClick" &&
        event.button === MouseBackButton
      ) {
        // Workaround for unexpected behaviour when user clicks the back button on their mouse on the backdrop
        // Aligns to the same behaviour as pressing the browser back button
        // Without this the dialog would close due to a button press on the backdrop,
        // updating pushing a new URL onto the location stack,
        // then the browser would process the navigate back action by popping the location stack,
        // resulting in the dialog being back in the URL and opening back up.

        // Don't navigate back
        event.preventDefault();

        // Don't allow anything else from navigating back
        event.stopPropagation();
      }
      dispatch(closeDispatchingModal(modalType));
    },
    [dispatch, modalType],
  );
};
